// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.daemon[data-v-02e31f9c]{padding:20px}.daemon h3[data-v-02e31f9c]{font-weight:bold}`, "",{"version":3,"sources":["webpack://./src/components/Apps/DaemonDetails.vue"],"names":[],"mappings":"AACA,yBACC,YAAA,CAEA,4BACC,gBAAA","sourcesContent":["\n.daemon {\n\tpadding: 20px;\n\n\th3 {\n\t\tfont-weight: bold;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
